import { useState, useContext } from 'react';
import { CircularProgress, Alert, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import TrainLoader from '../../General/TrainLoader';
import { AuthContext } from '../../../authentication/Auth';
import './SkillSubmission.css';

const forms = [
  { label: 'Form', src: 'https://airtable.com/embed/apptqxBrGc0b6cTY4/pagGvAvVrHDVYQcxL/form' },
  { label: 'Skills', src: 'https://airtable.com/embed/apptqxBrGc0b6cTY4/shrC3r72L0u5SRSe4?viewControls=on' },
];

const spinnerContainerStyle = {
  position: 'fixed', top: '50%', left: '50%',
  transform: 'translate(-50%, -50%)', zIndex: 100,
};

const SkillSubmission = () => {
  const { loading } = useContext(AuthContext);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [selected, setSelected] = useState(0);
  const [error] = useState(null);

  const handleChange = (e) => {
    setIframeLoaded(false);
    setSelected(Number(e.target.value));
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: 20 }}>
      {!iframeLoaded && <div style={spinnerContainerStyle}><TrainLoader /></div>}

      <Box sx={{ width: '100%', display: 'flex', marginBottom: 2 }}>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
          <InputLabel id="toggle-pages-label">Toggle Pages</InputLabel>
          <Select
            labelId="toggle-pages-label"
            value={selected}
            onChange={handleChange}
            label="Toggle Pages"
          >
            {forms.map((f, i) => (
              <MenuItem key={i} value={i}>{f.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <div style={{ display: iframeLoaded ? 'block' : 'none' }}>
        <iframe
          className="airtable-embed"
          src={forms[selected].src}
          frameBorder="0"
          width="100%"
          height="750px"
          style={{ background: 'transparent', border: '1px solid #ccc' }}
          title="Skill Submission"
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </div>
  );
};

export default SkillSubmission;
